import { css, CSSResult } from 'lit'
import {
  csColorBackground,
  csColorBorder,
  csColorFunctional,
  csColorText
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { cseIconSizes } from 'elements/icon/icon.style.js'


export const cseIconButton = {
  backgroundColorDisabled: css`var(--cse-icon-button-background-color-disabled, ${csColorBackground.disabled})`,
  borderColorDisabled: css`var(--cse-icon-button-border-color-disabled, ${csColorBorder.light})`,
  borderRadius: css`var(--cse-icon-button-border-radius, ${csBorder.radiusFull})`,
  borderWidth: css`var(--cse-icon-button-border-width, 0)`,
  colorDisabled: css`var(--cse-icon-button-color-disabled, ${csColorText.muted})`,

  primaryBackgrounColor: css`var(--cse-icon-button-primary-background-color, ${csColorBackground.primary})`,
  primaryBackgrounColorHover: css`var(--cse-icon-button-primary-background-color-hover, ${csColorBackground.primary})`,
  primaryBorderColor: css`var(--cse-icon-button-primary-border-color, ${csColorBackground.primary})`,
  primaryColor: css`var(--cse-icon-button-primary-color, ${csColorText.body})`,
  primaryColorHover: css`var(--cse-icon-button-primary-color-hover, ${csColorText.body})`,
  primaryBorderColorHover: css`var(--cse-icon-button-primary-border-color-hover, ${csColorBackground.primary})`,

  secondaryBackgroundColor: css`var(--cse-icon-button-secondary-background-color, ${csColorBackground.secondary})`,
  secondaryBackgroundColorHover: css`var(--cse-icon-button-secondary-background-color-hover, ${csColorBackground.secondary})`,
  secondaryBorderColor: css`var(--cse-icon-button-secondary-border-color, ${csColorBackground.secondary})`,
  secondaryColor: css`var(--cse-icon-button-secondary-color, ${csColorText.body})`,
  secondaryColorHover: css`var(--cse-icon-button-secondary-color-hover, ${csColorText.body})`,
  secondaryBorderColorHover: css`var(--cse-icon-button-secondary-border-color-hover, ${csColorBackground.secondary})`,

  ghostColor: css`var(--cse-icon-button-ghost-color, ${csColorText.body})`,
  ghostColorHover: css`var(--cse-icon-button-ghost-color-hover, ${csColorText.body})`,

  errorColor: css`var(--cse-icon-button-error-color, ${csColorFunctional.error})`,
  errorColorHover: css`var(--cse-icon-button-error-color-hover, ${csColorFunctional.errorHover})`,

  size: css`var(--cse-icon-button-size, 42px)`,
  smallSize: css`var(--cse-icon-button-small-size, 24px)`,

  boxShadow: css`var(--cse-icon-button-box-shadow, ${csShadow.default})`,

  fontSize: css`var(--cse-icon-button-font-size, ${cseIconSizes.sizeMd})`,
  smallFontSize: css`var(--cse-icon-button-small-font-size, ${cseIconSizes.sizeSm})`
}

export const style: CSSResult = css`
  .cse-icon-button {
    border-width: ${cseIconButton.borderWidth};
    border-style: solid;
    border-radius: ${cseIconButton.borderRadius};
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: ${csTransition.duration};
    transition-property: border-color, color, background-color;
    transition-timing-function: ${csTransition.timingFunction};
  }

  .cse-icon-button[disabled] {
    background-color: ${cseIconButton.backgroundColorDisabled};
    border-color: ${cseIconButton.borderColorDisabled};
    color: ${cseIconButton.colorDisabled};
    pointer-events: none;
  }

  .cse-icon-button.variant-ghost[disabled] {
    background: transparent;
  }

  .cse-icon-button:not([disabled]) {
    cursor: pointer;
  }

  /* SIZE */
  .size-default {
    height: ${cseIconButton.size};
    width: ${cseIconButton.size};
    font-size: ${cseIconButton.fontSize};
  }

  .size-small {
    height: ${cseIconButton.smallSize};
    width: ${cseIconButton.smallSize};
    font-size: ${cseIconButton.smallFontSize};
  }

  /* VARIANT */
  .variant-primary {
    color: ${cseIconButton.primaryColor};
    background-color: ${cseIconButton.primaryBackgrounColor};
    border-color: ${cseIconButton.primaryBorderColor};
  }

  .variant-primary:hover {
    background-color: ${cseIconButton.primaryBackgrounColorHover};
    color: ${cseIconButton.primaryColorHover};
    border-color: ${cseIconButton.primaryBorderColorHover};
  }

  .variant-secondary {
    color: ${cseIconButton.secondaryColor};
    background-color: ${cseIconButton.secondaryBackgroundColor};
    border-color: ${cseIconButton.secondaryBorderColor};
  }

  .variant-secondary:hover {
    background-color: ${cseIconButton.secondaryBackgroundColorHover};
    color: ${cseIconButton.secondaryColorHover};
    border-color: ${cseIconButton.secondaryBorderColorHover};
  }

  .variant-ghost {
    background-color: transparent;
    color: ${cseIconButton.ghostColor};
    border-width: 0;
  }

  .variant-ghost:hover {
    color: ${cseIconButton.ghostColorHover};
  }

  .cse-icon-button[error] {
    color: ${cseIconButton.errorColor};
  }

  .cse-icon-button[error]:hover {
    color: ${cseIconButton.errorColorHover};
  }

  .shadow {
    box-shadow: ${cseIconButton.boxShadow};
  }
`
